import { selectIsColumnsReady } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useIsColumnsReady(): boolean {
  return useEagGridSelector(selectIsColumnsReady);
}